import { render, staticRenderFns } from "./detailsUser.vue?vue&type=template&id=569ba7e1&"
import script from "./detailsUser.vue?vue&type=script&lang=js&"
export * from "./detailsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports